export const PlainlyOutputModule = {
    H_264: "H_264",
    H_264_HIGH_BIT_RATE: "H_264_HIGH_BIT_RATE",
    HQ: "HQ",
    HQ_ALPHA: "HQ_ALPHA"
} as const;

export const PlainlyPostEncoding = {
    CUSTOM: "custom",
    DEFAULT: "default",
    NONE: "none",
    SMALLEST: "smallest",
    SCALE: "scale"
} as const;

export const PlainlyEncodingFormat = {
    MP4: "MP4",
    GIF: "GIF",
    OGG: "OGG",
    WEBM: "WEBM",
    MOV: "MOV",
    MP4_H265: "MP4_H265",
    MXF: "MXF"
} as const;
